import { useRef } from 'react';
import { useSignalRHub, type ConnectionStatus } from '@/realtime/useSignalRHub';

// Pending Requests live hub (/hubs/pending-requests). Server pushes
// OnPendingCountChanged(requestType, pendingCount) → refetch the grids so a row
// resolved elsewhere leaves Requests / appears in History (and badges update).
export function usePendingRequestsHub({
  enabled,
  onPendingCountChanged,
}: {
  enabled: boolean;
  onPendingCountChanged: (requestType: number, pendingCount: number) => void;
}): { status: ConnectionStatus } {
  const onChangedRef = useRef(onPendingCountChanged);
  onChangedRef.current = onPendingCountChanged;

  const { status } = useSignalRHub({
    url: '/hubs/pending-requests',
    enabled,
    on: {
      OnPendingCountChanged: (requestType, pendingCount) => {
        onChangedRef.current(Number(requestType), Number(pendingCount));
      },
    },
  });

  return { status };
}
